export default function ProgressBar({
  progressValue,
  className,
}: {
  progressValue: number;
  className?: string;
}) {
  return (
    <div
      className={`h-1 rounded mx-auto ${className}`}
      role="progressbar"
      aria-valuenow={progressValue}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className="h-full rounded bg-white transition-all"
        style={{ width: `${progressValue}%` }}
      />
    </div>
  );
}
